import { Flex, Icon, useColorMode } from "@chakra-ui/react";
import React from "react";

const DocNavItem = (props) => {
  const { icon, children, to, ...rest } = props;
  const [activeId, setActiveId] = React.useState();
  const { colorMode } = useColorMode();

  const useIntersectionObserver = (setActiveId) => {
    const headingElementsRef = React.useRef({});
    React.useEffect(() => {
      const callback = (headings) => {
        headingElementsRef.current = headings.reduce((map, headingElement) => {
          map[headingElement.target.id] = headingElement;
          return map;
        }, headingElementsRef.current);

        // Get all headings that are currently visible on the page
        const visibleHeadings = [];
        Object.keys(headingElementsRef.current).forEach((key) => {
          const headingElement = headingElementsRef.current[key];
          if (headingElement.isIntersecting)
            visibleHeadings.push(headingElement);
        });

        const getIndexFromId = (id) =>
          headingElements.findIndex((heading) => heading.id === id);

        // If there is only one visible heading, this is our "active" heading
        if (visibleHeadings.length === 1) {
          setActiveId(visibleHeadings[0].target.id);
          // If there is more than one visible heading,
          // choose the one that is closest to the top of the page
        } else if (visibleHeadings.length > 1) {
          const sortedVisibleHeadings = visibleHeadings.sort(
            (a, b) => getIndexFromId(a.target.id) > getIndexFromId(b.target.id)
          );

          setActiveId(sortedVisibleHeadings[0].target.id);
        }
      };

      const observer = new IntersectionObserver(callback, {
        root: document.querySelector("iframe"),
        rootMargin: "500px",
      });

      const headingElements = Array.from(document.querySelectorAll("h1"));

      headingElements.forEach((element) => observer.observe(element));

      return () => observer.disconnect();
    }, [setActiveId]);
  };
  useIntersectionObserver(setActiveId);
  return (
    <Flex
      align="center"
      onClick={(e) => {
        e.preventDefault();
        document.querySelector(`#${to}`).scrollIntoView({
          behavior: "smooth",
        });
      }}
      px="4"
      mx="2"
      rounded="md"
      py="3"
      bg={activeId === to ? "brand.500" : null}
      cursor="pointer"
      color={
        activeId === to
          ? "whiteAlpha.900"
          : colorMode === "light"
          ? "blackAlpha.700"
          : "white"
      }
      _hover={{
        bg: "brand.500",
        color: "whiteAlpha.900",
      }}
      role="group"
      fontSize={{ base: "sm", "2xl": "md", "3xl": "lg", "5xl": "xl" }}
      fontWeight="bold"
      transition=".15s ease"
      {...rest}
    >
      {icon && (
        <Icon
          mr="2"
          boxSize="4"
          _groupHover={{
            color: "gray.300",
          }}
          as={icon}
        />
      )}
      {children}
    </Flex>
  );
};

export default DocNavItem;
